var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M2.117 2.117c.582 0 1.058-.477 1.058-1.059S2.699 0 2.117 0c-.582 0-1.059.476-1.059 1.058 0 .582.477 1.059 1.059 1.059zm0 .529C1.402 2.646 0 2.99 0 3.704v.53h4.233v-.53c0-.714-1.402-1.058-2.116-1.058z"}})}
var staticRenderFns = []

export { render, staticRenderFns }